import { FileList } from "@dgs/core";

import { FC } from "react";

export const FilesPage: FC = () => {
	return <FileList />;
};
